import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { SeguimientoService } from '../../../services/formulacion/seguimiento.service';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-seguimiento-inicio',
  templateUrl: './seguimiento-inicio.component.html',
  styles: [],
  providers: [GeneralService]
})
export class SeguimientoInicioComponent implements OnInit {
  techos: any[];
  mesId: number = 0;
  baseUrl = environment.apiEndpoint;
  es_aprobado = false

  constructor(private _gs: GeneralService, private _ss: SeguimientoService) {
    this.getTechoByUO();

    this._ss.getMesDeReporte().subscribe(
      (Response) => {
        let result = UtilHelper.responses(Response);
        if (result.status == 200) {
          this.mesId = result.data.id;
        }
      }
    );
  }

  ngOnInit() {
  }

  getTechoByUO() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this._gs.getTechoByUO(u.unidad).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.techos = result.data;
          } else {
            this.techos = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  openReport(techoId: number, mesId: number) {        
    this._ss.getValidaIndicadores(techoId, mesId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);        
        if (result.status == 200) {
          const reportUrl = `${this.baseUrl}reportes/pdfReporteAvanceMensual/${techoId}/${mesId}`;
          window.open(reportUrl, '_blank');
        } else if (result.status == 201) {
          toastr.warning('Falta reportar algunos indicadores.');          
        } else if (result.status == 202) {          
          toastr.warning('Para poder imprimir el Formulario 1, todos los indicadores deben estar en estado consolidado por la DGP.');
        }
      },
      (error) => { console.log('Error', error); });
  }
  
}
